import Header from '../components/Header/Header'
import Footer from '../components/Footer/Footer'
import Routers from '../routers/Routers';
import SmoothScrollProvider from '../components/shared/smooth-scroll';


const Layout = () => {
  return (
    <>
    <SmoothScrollProvider>
    <Header />  
    <div>
        <Routers />
    </div>
    <Footer />
    </SmoothScrollProvider>
    </>
  );
};

export default Layout